import {
  DeliverQuestion,
  DeliverSuccess,
  InvoiceDocumentSuccess,
  LoadApplySuccess,
  PickupSuccess,
  PickupWithoutBarcodeQuestion,
  TripLegDocumentSuccess,
} from '../../components/modals'

export enum ModalEnum {
  DeliverQuestion = 'DeliverQuestion',
  DeliverSuccess = 'DeliverSuccess',
  InvoiceDocumentSuccess = 'InvoiceDocumentSuccess',
  LoadApplySuccess = 'LoadApplySuccess',
  PickupSuccess = 'PickupSuccess',
  PickupWithoutBarcodeQuestion = 'PickupWithoutBarcodeQuestion',
  TripLegDocumentSuccess = 'TripLegDocumentSuccess',
}

export default {
  [ModalEnum.DeliverQuestion]: DeliverQuestion,
  [ModalEnum.DeliverSuccess]: DeliverSuccess,
  [ModalEnum.InvoiceDocumentSuccess]: InvoiceDocumentSuccess,
  [ModalEnum.LoadApplySuccess]: LoadApplySuccess,
  [ModalEnum.PickupSuccess]: PickupSuccess,
  [ModalEnum.PickupWithoutBarcodeQuestion]: PickupWithoutBarcodeQuestion,
  [ModalEnum.TripLegDocumentSuccess]: TripLegDocumentSuccess,
}
